import { Button } from "@/components/ui/button";
import { ModeToggle } from "@/components/theme-toggle";
import { Zap } from "lucide-react";
import { motion } from "framer-motion";

export function Header() {
  return (
    <motion.header 
      className="sticky top-0 z-50 w-full border-b border-border/40 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="container flex h-16 items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary">
            <Zap className="h-5 w-5 text-primary-foreground" />
          </div>
          <span className="text-xl font-bold">MEP AI</span>
        </div>

        <nav className="hidden md:flex items-center gap-8">
          <a href="#features" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
            Features
          </a>
          <a href="#calculations" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
            Calculations
          </a>
          <a href="#disciplines" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
            Disciplines
          </a>
        </nav>

        <div className="flex items-center gap-3">
          <ModeToggle />
          <Button variant="ghost" className="hidden md:inline-flex">
            Sign In
          </Button>
          <Button>Get Started</Button>
        </div>
      </div>
    </motion.header>
  );
}